import { FC, useState } from "react";
import { PageHeader } from "../../components/PageHeader";
import { PullRequests } from "../../modules/PullRequests";
import { PullRequestBranch } from "../../modules/PullRequests/PullRequests.types";
import "./style.css";

const TABS: { branch: PullRequestBranch; label: string; description: string }[] = [
  {
    branch: "master",
    label: "Production",
    description:
      "Active pull requests targeting master, then the latest completed ones. Linked work items show whether Soft config required is Yes.",
  },
  {
    branch: "release",
    label: "UAT",
    description:
      "Active pull requests targeting release, then the latest completed ones. Linked work items show whether Soft config required is Yes.",
  },
];

export const PullRequestsPage: FC = () => {
  const [branch, setBranch] = useState<PullRequestBranch>("master");
  const selected = TABS.find((tab) => tab.branch === branch) ?? TABS[0];

  return (
    <div className="pull-requests-page">
      <PageHeader header="Pull requests" description={selected.description} />
      <div className="pull-request-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.branch}
            type="button"
            role="tab"
            aria-selected={tab.branch === branch}
            className={
              tab.branch === branch
                ? "pull-request-tab pull-request-tab-active"
                : "pull-request-tab"
            }
            onClick={() => setBranch(tab.branch)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <PullRequests key={branch} branch={branch} />
    </div>
  );
};
